import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=238098b6&"
import script from "./PdfViewer.vue?vue&type=script&lang=ts&"
export * from "./PdfViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports